<template>
  <el-row class="bids-dop-menu">
    <el-col :span="24">
      <el-dropdown trigger="click">
        <el-button type="info" class="btn-dropdown btn-dop-menu" plain>
          доп. меню
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <div class="additional-menu-container">
            <el-dropdown-item
              icon="el-icon-plus"
              @click.native="handleAddNewResponses"
            >
              Добавить новые отклики
            </el-dropdown-item>
            <el-dropdown-item
              icon="el-icon-circle-check"
              @click.native="reportChecked"
            >
              Отчет проверен
            </el-dropdown-item>
            <el-dropdown-item
              icon="el-icon-check"
              @click.native="reportSubmitted"
            >
              Отчет сдан
            </el-dropdown-item>
            <el-dropdown-item
              icon="el-icon-document-add"
              @click.native="appendFile"
            >
              Прикрепить файл сданного отчета
            </el-dropdown-item>
            <el-dropdown-item
              icon="el-icon-download"
              @click.native="handleDownloadReportWithoutScan"
            >
              Скачать файлы к отчету без сканов
            </el-dropdown-item>
            <el-dropdown-item
              icon="el-icon-download"
              @click.native="handleDownloadReport()"
            >
              Скачать файлы к отчету со сканами
            </el-dropdown-item>
            <registry-pay-button :id="report.id" />
            <el-dropdown-item
              icon="el-icon-circle-close"
              @click.native="delReport"
            >
              Удалить отчет
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>

      <form-save-nomenclature-without-scan
        :visible="isOpenModalNomenclatureWithoutScan"
        :cur-bid="bid.id"
        :status-download="statusDownloadNomenclature"
        :link-download="linkDownloadNomenclature"
        @save="saveNomenclature"
        @close="closeNomenclatureWithoutScan"
      />

      <form-save-nomenclature
        :visible="isOpenModalNomenclature"
        :cur-bid="bid.id"
        :status-download="statusDownloadNomenclature"
        :link-download="linkDownloadNomenclature"
        @save="saveNomenclature"
        @close="closeNomenclature"
      />

      <form-add-new-responses
        :visible="isOpenModalAddNewResponses"
        :report-id="report.id"
        :bid-id="bid.id"
        :type="bid.type_code"
        @close="isOpenModalAddNewResponses = false"
      />
    </el-col>
  </el-row>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

import { SET_PROGRESS_BAR, SET_STATUS_DOWNLOAD } from '@/store/actions/reports'

import FormAddNewResponses from '@/views/Report/Modals/AddNewResponses/AddNewResponses'
import FormSaveNomenclature from '@/components/Forms/FormSaveNomenclature'
import FormSaveNomenclatureWithoutScan from '@/components/Forms/FormSaveNomenclatureWithoutScan'
import RegistryPayButton from './RegistryPayButton'

import shippingMixin from '@/mixins/shippingMixin'

const Doc = RepositoryFactory.get('doc')
const TotalReportAPI = RepositoryFactory.get('totalReport')

export default {
  name: 'AdditionalMenu',
  components: {
    FormSaveNomenclature,
    FormSaveNomenclatureWithoutScan,
    FormAddNewResponses,
    RegistryPayButton,
  },
  mixins: [shippingMixin],
  props: {
    report: {
      type: Object,
      default: () => {},
    },
    bid: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isOpenModalNomenclature: false,
      isOpenModalNomenclatureWithoutScan: false,
      isOpenModalAddNewResponses: false,
      linkDownloadNomenclature: '',
    }
  },
  computed: {
    statusDownloadNomenclature: {
      get() {
        return this.$store.getters[`reports/getStatusDownload`]
      },
      set(value) {
        this.$store.dispatch(`reports/${SET_STATUS_DOWNLOAD}`, value)
      },
    },
  },
  methods: {
    closeNomenclatureWithoutScan() {
      this.isOpenModalNomenclatureWithoutScan = false
      this.statusDownloadNomenclature = ''
      this.$store.dispatch(`reports/${SET_PROGRESS_BAR}`, 0)
    },
    closeNomenclature() {
      this.isOpenModalNomenclature = false
      this.statusDownloadNomenclature = ''
    },
    async reportSubmitted() {
      const options = {
        link_by_rel: 'totalReports',
        link_by_id: this.report.id,
        user_org_inn: this.userInfo.current.organization.inn,
        create_master_approve: 1,
        status: 1,
      }

      await TotalReportAPI.setApprovements(options)
        .then(() => this.$message.success('Установлен статус "Отчет сдан"'))
        .catch(e => console.log(e))
    },
    reportChecked() {},
    appendFile() {},
    handleDownloadReportWithoutScan() {
      this.isOpenModalNomenclatureWithoutScan = true
    },
    handleDownloadReport() {
      this.isOpenModalNomenclature = true
    },
    handleAddNewResponses() {
      this.isOpenModalAddNewResponses = true
    },
    async saveNomenclature(options) {
      await Doc.generateReport(
        this.report.id,
        options.scoupe,
        options.watermark,
        options.combine,
        options.item,
        options['black_white'],
      )
        .then(response => {
          this.$message('Загрузка отчет скоро начнется')
          const reportId = response.data.id
          let timer = setInterval(() => {
            Doc.getReportFiles('total-report', reportId).then(res => {
              this.$store.dispatch(
                `reports/${SET_PROGRESS_BAR}`,
                res.data.readiness,
              )

              if (res.data.readiness === 100) {
                this.$message('Загрузка отчета началась')
                setTimeout(() => {
                  const path = Doc.getReportLink(
                    `total-report/${reportId}/download`,
                  )

                  this.downloadRegistry({ path })
                  this.statusDownloadNomenclature = 'ready'
                  clearInterval(timer)
                }, 1000)
              }
            })
          }, 2000)
        })
        .catch(() => {
          this.$message('Что то пошло не так')
          this.isOpenModalNomenclature = false
        })
    },
    delReport() {
      this.$confirm('Вы уверены что хотите удалить отчет?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
      })
        .then(() => {
          TotalReportAPI.deleteReport(this.report.id)
            .then(() => this.$router.push('/reports'))
            .catch(err => this.errHandler(err))
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="sass">
.additional-menu-container
  font-family: 'Rubik', sans-serif
  font-size: 14px
  line-height: 1.6
  min-width: 200px
  display: block
  text-align: left
</style>
